import React from "react"
import Slider from "react-slick";
import imagebvlgari from "images/clients/bvlgari.jpg"
import imagesalesforce from "images/clients/salesforce.jpg"
import imageibm from "images/clients/ibm.jpg"
import imagelogitech from "images/clients/logitech.jpg"
import imagemarketo from "images/clients/marketo.jpg"
import imagemcafee from "images/clients/mcafee.jpg"
import imagepwc from "images/clients/pwc.jpg"
import imagequaltrics from "images/clients/qualtrics.jpg"
import imagetripadvisor from "images/clients/tripadvisor.jpg"
import imagewellsfargo from "images/clients/wellsfargo.jpg"
import imagetwilio from "images/clients/twilio.jpg"
import imagecadence from "images/clients/cadence.jpg"
import imagecapita from "images/clients/capita.jpg"
import imagezynga from "images/clients/zynga.jpg"
import imageheineken from "images/clients/heineken.jpg"
import imageomnicom from "images/clients/omnicom.jpg"
import imagewebsummit from "images/clients/websummit.jpg"
import imagewrike from "images/clients/wrike.jpg"
import imagemastercard from "images/clients/mastercard.jpeg"
import imagecantor from "images/clients/cantor.jpg"
import image8w from "images/clients/8w.jpg"
import imagecognex from "images/clients/cognex.jpg"
import imagecoupa from "images/clients/coupa.jpg"
import imagedatalex from "images/clients/datalex.jpg"
import imagegoodbody from "images/clients/goodbody.jpg"
import imagegso from "images/clients/gso.jpg"
import imagehedgeserv from "images/clients/hedgeserv.jpg"
import imagemckesson from "images/clients/mckesson.jpg"
import imagefineos from "images/clients/fineos.jpg"
import imageavolon from "images/clients/avolon.jpg"
import imagestandardlife from "images/clients/standardlife.jpg"
import imagepaulson from "images/clients/paulson.jpg"
import imageirishjobs from "images/clients/irishjobs.jpg"
import imagesocialtalent from "images/clients/socialtalent.jpg"
import imageworkday from "images/clients/workday.jpg"
import imagequantcast from "images/clients/quantcast.jpg"
import imageteneo from "images/clients/teneo.jpg"
import imageorix from "images/clients/orix.jpg"
import imagecorehr from "images/clients/corehr.jpg"
import imagepilz from "images/clients/pilz.jpg"
import imagesegment from "images/clients/segment.jpg"
import imagekooomo from "images/clients/kooomo.jpg"
import imagemazars from "images/clients/mazars.jpg"
import imageglanbia from "images/clients/glanbia.jpg"
import imageapplovin from "images/clients/applovin.jpg"
import imagegenesis from "images/clients/genesis.jpg"
import imagelbec from "images/clients/lbec.jpg"
import imagerockall from "images/clients/rockall.jpg"
import imageneam from "images/clients/neam.jpg"

const clients = props => {
  var settings = {
    speed: 500,
    responsive: [
      {
        breakpoint: 5000,
        settings: 'unslick'
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  };
  return (
    <div ref={props.ourClientsRef} className="secao-6" id="some-of">
      <div className="wrap">
        <h1>Some of Our Clients</h1>
        <ul className="clients">
          <li>
            <a>
              <img alt="Bvlgari" src={imagebvlgari} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Salesforce" src={imagesalesforce} />
            </a>
          </li>
          <li>
            <a>
              <img alt="IBM" src={imageibm} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Logitech" src={imagelogitech} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Marketo" src={imagemarketo} />
            </a>
          </li>
          <li>
            <a>
              <img alt="McAfee" src={imagemcafee} />
            </a>
          </li>
          <li>
            <a>
              <img alt="PWC" src={imagepwc} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Qualtrics" src={imagequaltrics} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Tripadvisor" src={imagetripadvisor} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Wells Fargo" src={imagewellsfargo} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Twilio" src={imagetwilio} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Cadence Bank" src={imagecadence} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Capita" src={imagecapita} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Zynga" src={imagezynga} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Heineken" src={imageheineken} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Omnicon" src={imageomnicom} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Websummit" src={imagewebsummit} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Wrike" src={imagewrike} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Mastercard" src={imagemastercard} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Cantor" src={imagecantor} />
            </a>
          </li>
          <li>
            <a>
              <img alt="8w" src={image8w} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Cognex" src={imagecognex} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Coupa" src={imagecoupa} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Datalex" src={imagedatalex} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Goodbody" src={imagegoodbody} />
            </a>
          </li>
          <li>
            <a>
              <img alt="GSO" src={imagegso} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Hedgeserv" src={imagehedgeserv} />
            </a>
          </li>
          <li>
            <a>
              <img alt="McKesson" src={imagemckesson} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Fineos" src={imagefineos} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Avolon" src={imageavolon} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Standard Life" src={imagestandardlife} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Paulson" src={imagepaulson} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Irish Jobs" src={imageirishjobs} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Social Talent" src={imagesocialtalent} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Workday" src={imageworkday} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Quantcast" src={imagequantcast} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Teneo" src={imageteneo} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Orix" src={imageorix} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Corehr" src={imagecorehr} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Pilz" src={imagepilz} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Segment" src={imagesegment} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Kooomo" src={imagekooomo} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Mazars" src={imagemazars} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Glanbia" src={imageglanbia} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Applovin" src={imageapplovin} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Genesis" src={imagegenesis} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Lbec" src={imagelbec} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Rockall" src={imagerockall} />
            </a>
          </li>
          <li>
            <a>
              <img alt="Neam" src={imageneam} />
            </a>
          </li>
        </ul>
        <Slider className="clients-mobile" {...settings}>
          <div>
            <a>
              <img alt="Bvlgari" src={imagebvlgari} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Salesforce" src={imagesalesforce} />
            </a>
          </div>
          <div>
            <a>
              <img alt="IBM" src={imageibm} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Logitech" src={imagelogitech} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Marketo" src={imagemarketo} />
            </a>
          </div>
          <div>
            <a>
              <img alt="McAfee" src={imagemcafee} />
            </a>
          </div>
          <div>
            <a>
              <img alt="PWC" src={imagepwc} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Qualtrics" src={imagequaltrics} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Tripadvisor" src={imagetripadvisor} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Wells Fargo" src={imagewellsfargo} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Twilio" src={imagetwilio} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Cadence Bank" src={imagecadence} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Capita" src={imagecapita} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Zynga" src={imagezynga} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Heineken" src={imageheineken} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Omnicon" src={imageomnicom} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Websummit" src={imagewebsummit} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Wrike" src={imagewrike} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Udemy" src={imagemastercard} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Cantor" src={imagecantor} />
            </a>
          </div>
          <div>
            <a>
              <img alt="8w" src={image8w} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Cognex" src={imagecognex} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Coupa" src={imagecoupa} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Datalex" src={imagedatalex} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Goodbody" src={imagegoodbody} />
            </a>
          </div>
          <div>
            <a>
              <img alt="GSO" src={imagegso} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Hedgeserv" src={imagehedgeserv} />
            </a>
          </div>
          <div>
            <a>
              <img alt="McKesson" src={imagemckesson} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Fineos" src={imagefineos} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Avolon" src={imageavolon} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Paulson" src={imagepaulson} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Irish Jobs" src={imageirishjobs} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Social Talent" src={imagesocialtalent} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Workday" src={imageworkday} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Quantcast" src={imagequantcast} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Teneo" src={imageteneo} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Orix" src={imageorix} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Corehr" src={imagecorehr} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Pilz" src={imagepilz} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Segment" src={imagesegment} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Kooomo" src={imagekooomo} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Mazars" src={imagemazars} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Glanbia" src={imageglanbia} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Applovin" src={imageapplovin} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Genesis" src={imagegenesis} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Lbec" src={imagelbec} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Rockall" src={imagerockall} />
            </a>
          </div>
          <div>
            <a>
              <img alt="Neam" src={imageneam} />
            </a>
          </div>
        </Slider>
        <a onClick={props.HandleFindOutMore} className="bt get-more-info">Find out more</a>
      </div>
    </div>
  )
}

export default clients



// WEBPACK FOOTER //
// ./src/containers/Landing/Clients/index.js